// import React from "react"
// // import React, { useState } from "react"
// import addToMailchimp from "gatsby-plugin-mailchimp"
// export default function EmailListForm() {
//   //   const [email, setEmail] = useState("")
//   //   const handleSubmit = e => {
//   //     e.preventDefault()
//   //   }

//   //   const handleEmailChange = event => {
//   //     setEmail(event.currentTarget.value)
//   //   }
//   const handleSubmit = e => {
//     e.preventDefault()
//     addToMailchimp("freelancology@gmail.com", {
//       PATHNAME: "/blog-post-1",
//       FNAME: "emailhere",
//       email: "Shahid",
//     })
//       .then(data => {
//         console.log(data)
//         alert(data.result)
//       })
//       .catch(() => {
//         // unnecessary because Mailchimp only ever
//         // returns a 200 status code
//         // see below for how to handle errors
//       })
//   }
//   return (
//     <div className=" center bg-white m-0 p-4 w-100 shadow  border-bottom-1 border-primary">
//       <h5 className="text-center">Subscribe to our Newsletter</h5>
//       <form className="text-center" onSubmit={_handleSubmit}>
//         <div className="form-Group">
//           <input
//             type="email"
//             name="email"
//             class="form-control"
//             id="inputEmail4"
//             placeholder="Enter Your Email"
//             onChange={_handleChange}}
//           />
//         </div>
//         <button
//           outline
//           color="primary"
//           className="btn btn-outline-primary w-100 text-center mt-2"
//           type="submit"
//         >
//           Subscribe
//         </button>{" "}
//       </form>
//     </div>
//   )
// }

/* eslint no-console:0 no-alert:0 */
import React from "react"
import addToMailchimp from "gatsby-plugin-mailchimp"

export default class EmailListForm extends React.Component {
  state = {
    email: null,
  }

  _handleChange = e => {
    console.log({
      [`${e.target.name}`]: e.target.value,
    })
    this.setState({
      [`${e.target.name}`]: e.target.value,
    })
  }

  _handleSubmit = e => {
    e.preventDefault()

    console.log("submit", this.state)

    addToMailchimp(this.state.email, this.state)
      .then(({ msg, result }) => {
        console.log("msg", `${result}: ${"textSMG"}`)
        console.log(result)
        if (result !== "success") {
          throw msg
        }
        alert(result)
      })
      .catch(err => {
        alert(`${this.state.email} is already subscribed to list Freelancology`)
      })
  }

  render() {
    return (
      <div className=" center bg-white m-0 p-4 w-100 shadow  border-bottom-1 border-primary">
        <h5 className="text-center">Subscribe to our Newsletter</h5>
        <form className="text-center" onSubmit={this._handleSubmit}>
          <div className="form-Group">
            <input
              type="email"
              name="email"
              class="form-control"
              id="inputEmail4"
              placeholder="Enter Your Email"
              onChange={this._handleChange}
            />
          </div>
          <button
            outline
            color="primary"
            className="btn btn-outline-primary w-100 text-center mt-2"
            type="submit"
          >
            Subscribe
          </button>{" "}
        </form>
      </div>
    )
  }
}
